import React, { useState } from "react";
import MarketingCampaigns from "@/components/marketing/MarketingCampaigns";
import MarketingCampaignsTab from "@/components/marketing/MarketingCampaignsTab";
import MarketingCandidates from "@/components/marketing/MarketingCandidates";
import MarketingHistory from "@/components/marketing/MarketingHistory";

const TABS = [
  { id: "templates", label: "Templates" },
  { id: "campaigns", label: "Campaigns" },
  { id: "candidates", label: "Candidates" },
  { id: "history", label: "History" },
];

const getInitialTab = () => {
  const saved = localStorage.getItem("marketing_activeTab");
  return TABS.some((tab) => tab.id === saved) ? saved : "templates";
};

const TAB_DESCRIPTIONS = {
  templates: "Create and manage email and SMS templates.",
  campaigns:
    "Create campaigns from templates and select candidates for each campaign.",
  candidates:
    "All candidates who have SMS or email marketing opted in.",
  history:
    "See every campaign send as its own row, with channel, recipients, and sent time.",
};

const Marketing = () => {
  const [activeTab, setActiveTab] = useState(getInitialTab);

  const handleTabChange = (tabId) => {
    localStorage.setItem("marketing_activeTab", tabId);
    setActiveTab(tabId);
  };

  const renderTabContent = () => {
    switch (activeTab) {
      case "templates":
        return <MarketingCampaigns />;
      case "campaigns":
        return <MarketingCampaignsTab />;
      case "candidates":
        return <MarketingCandidates />;
      case "history":
        return <MarketingHistory />;
      default:
        return null;
    }
  };

  return (
    <div className="marketing-page-scope flex flex-col min-h-screen bg-background">
      <div className="flex-1 w-[90%] max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-8 md:pt-12 flex flex-col gap-5 sm:gap-6">
        <div className="flex flex-col gap-1">
          <h1 className="text-foreground text-xl sm:text-2xl font-semibold leading-8">
            Marketing
          </h1>
          <p className="text-muted-foreground text-sm sm:text-base font-normal leading-6">
            {TAB_DESCRIPTIONS[activeTab] || TAB_DESCRIPTIONS.templates}
          </p>
        </div>

        <div>
          <nav className="flex overflow-x-auto">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                type="button"
                onClick={() => handleTabChange(tab.id)}
                className={`px-6 py-4 text-sm font-medium border-b-2 whitespace-nowrap ${
                  activeTab === tab.id
                    ? "border-foreground text-foreground"
                    : "border-transparent text-muted-foreground hover:text-foreground hover:border-input"
                }`}
              >
                {tab.label}
              </button>
            ))}
          </nav>
        </div>

        {renderTabContent()}
      </div>
    </div>
  );
};

export default Marketing;
